import { types } from 'mobx-state-tree';
import Actions from './actions';
const FreeTrailDecisionPopup = types
    .model({
    displayPopupByUserAction: types.optional(types.boolean, false),
    displayPopupByCTA: types.optional(types.boolean, false),
    showFailLimitReason: types.optional(types.string, ''),
})
    .actions(Actions);
export default FreeTrailDecisionPopup;
